// react_frontend/src/Components/Modules/Accounting/ProfitLoss.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Divider
} from '@mui/material';
import { FaSearch, FaArrowUp, FaArrowDown } from 'react-icons/fa';

export default function ProfitLoss() {
    const [revenues, setRevenues] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [totalExpense, setTotalExpense] = useState(0);
    const [netProfit, setNetProfit] = useState(0);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const fetchPL = async () => {
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/profit-loss', {
                params: { from_date: fromDate, to_date: toDate }
            });
            setRevenues(res.data.revenues || []);
            setExpenses(res.data.expenses || []);
            setTotalRevenue(res.data.total_revenue || 0);
            setTotalExpense(res.data.total_expense || 0);
            setNetProfit(res.data.net_profit || 0);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchPL(); }, []);

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Profit & Loss" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>Profit & Loss Statement</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField label="From Date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <TextField label="To Date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchPL} startIcon={<FaSearch />}>Generate</Button>
                </Box>

                <Typography variant="h6" color="success.main" sx={{ mb: 1 }}><FaArrowUp style={{ marginRight: 8 }} />Revenue</Typography>
                <TableContainer sx={{ mb: 3 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#e8f5e9' }}>
                                <TableCell>Code</TableCell>
                                <TableCell>Account</TableCell>
                                <TableCell align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {revenues.map((r, idx) => (
                                <TableRow key={idx}>
                                    <TableCell><code>{r.account_code}</code></TableCell>
                                    <TableCell>{r.account_name}</TableCell>
                                    <TableCell align="right">৳{Number(r.amount).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#c8e6c9', fontWeight: 700 }}>
                                <TableCell colSpan={2}><strong>Total Revenue</strong></TableCell>
                                <TableCell align="right"><strong>৳{Number(totalRevenue).toLocaleString()}</strong></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" color="error.main" sx={{ mb: 1 }}><FaArrowDown style={{ marginRight: 8 }} />Expenses</Typography>
                <TableContainer sx={{ mb: 3 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#ffebee' }}>
                                <TableCell>Code</TableCell>
                                <TableCell>Account</TableCell>
                                <TableCell align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {expenses.map((e, idx) => (
                                <TableRow key={idx}>
                                    <TableCell><code>{e.account_code}</code></TableCell>
                                    <TableCell>{e.account_name}</TableCell>
                                    <TableCell align="right">৳{Number(e.amount).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ bgcolor: '#ffcdd2', fontWeight: 700 }}>
                                <TableCell colSpan={2}><strong>Total Expenses</strong></TableCell>
                                <TableCell align="right"><strong>৳{Number(totalExpense).toLocaleString()}</strong></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ p: 3, bgcolor: netProfit >= 0 ? '#e8f5e9' : '#ffebee', borderRadius: 2, textAlign: 'center' }}>
                    <Typography variant="h6" fontWeight={700}>Net {netProfit >= 0 ? 'Profit' : 'Loss'}</Typography>
                    <Typography variant="h4" fontWeight={800} color={netProfit >= 0 ? 'success.main' : 'error.main'}>
                        ৳{Number(Math.abs(netProfit)).toLocaleString()}
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
}